<template>
    <div class="photo-library">
        <!-- 分类选择器 -->
        <div class="album-filter">
            <div class="album-tabs">
                <button :class="['album-tab', { selected: selectedAlbum === 'all' }]"
                    @click="selectAlbum('all')">All</button>
                <!-- 管理页面模式下显示所有分类和添加按钮 -->
                <template v-if="currentMessageType === 'management' || !editMode">
                    <div v-for="album in albumList" :key="album.idAlbum" class="album-item">
                        <button :class="['album-tab', { selected: selectedAlbum === album.idAlbum }]"
                            @click="selectAlbum(album.idAlbum)">
                            {{ album.name }}
                        </button>
                        <button class="album-delete-btn" @click="deleteAlbum(album)" title="删除分类">
                            <i class="el-icon-delete"></i>
                        </button>
                    </div>
                    <button class="album-tab add-album" @click="showCreateAlbumModal = true" title="创建新分类">
                        <i class="el-icon-plus"></i>
                    </button>
                </template>
            </div>
        </div>

        <!-- 分类标签和筛选条件 -->
        <div class="status-filter-btns">
            <div class="status-buttons">
                <button v-for="item in filteredCategoryOptions" :key="item.value"
                    :class="['status-btn', { selected: selectedCategory === item.value }]"
                    @click="selectCategory(item.value)">
                    {{ item.label }}
                </button>
            </div>
            <!-- Show only unseen 筛选开关 -->
            <div class="unseen-filter">
                <label class="toggle-switch">
                    <input type="checkbox" v-model="showOnlyUnseen" @change="handleUnseenFilterChange">
                    <span class="toggle-slider"></span>
                    <span class="toggle-label">Show only unseen</span>
                </label>
            </div>
            <!-- 添加图片按钮 - 当选择了非All的子分类时显示 -->
            <button v-if="selectedAlbum !== 'all' && (currentMessageType === 'management' || !editMode)" class="add-photo-btn"
                @click="addPhotosToCurrentCategory" title="添加图片到此分类">
                <i class="el-icon-plus"></i>
                添加图片
            </button>
        </div>

        <!-- 照片列表 -->
        <ul class="photo-list" :key="infiniteScrollKey" v-infinite-scroll="loadMore" :infinite-scroll-disabled="isLoading || isNoMore"
            :infinite-scroll-distance="200">
            <li :class="['photo-item', { 'is-selected': item.isClicked }]" v-for="(item, i) in photoList" :key="i"
                @click="toggleSelect(item)" @mouseenter="item.isHovered = true" @mouseleave="item.isHovered = false"
                :style="{ cursor: getCursorStyle(item) }">
                <div class="image-container" :class="{ 'disabled-image': isDisabled(item) }">
                    <imagePreview :src="item.url" :preview-src="item.originalUrl" :preview-src-list="previewImageList"
                        :current-index="getPreviewIndex(item)" :alt="item.originalName || '图片'" @click.stop />

                    <!-- 图标容器 -->
                    <div class="media-icons-container">
                        <!-- 标签图标 -->
                        <el-tooltip placement="top" effect="light" :content="getTagDescription(item)"
                            v-if="getIsShowTag(item)">
                            <div class="media-tag">
                                <img :src="getTagIcon(item)" class="tag-icon" />
                            </div>
                        </el-tooltip>
                        <!-- 是否发送过 -->
                        <el-tooltip placement="top" effect="light" :content="'发送过'" v-if="item.casualStatus == 'sent'">
                            <div class="media-tagSec">
                                <i class="el-icon-s-promotion" style="color: #fff;font-size: 18px;"></i>
                            </div>
                        </el-tooltip>
                        <!-- 是否查看过 -->
                        <el-tooltip placement="top" effect="light" :content="'查看过'"
                            v-if="item.casualStatus == 'accessed'">
                            <div class="media-tagSec" style="background: rgba(255, 255, 255, 0.7);">
                                <!-- <i class="el-icon-view" style="color: #292DBD;font-size: 18px;"></i> -->
                                <!-- <img src="@/src/assets/seen.png" style="width: 18px;height: 18px;"> -->
                                <img src="@/assets/see.png" style="width: 14px;">
                            </div>
                        </el-tooltip>
                        <!-- 重新审核按钮 -->
                        <el-tooltip placement="top" effect="light" :content="'重新审核'"
                            v-if="shouldShowReReview(item) && item.isHovered">
                            <div class="media-tagSec" @click="reReview(item)">
                                <i class="el-icon-refresh-right" style="color: #fff;font-size: 18px;"></i>
                            </div>
                        </el-tooltip>
                    </div>

                    <!-- 灰色蒙版 -->
                    <div v-if="shouldShowOverlay(item)" class="disabled-overlay"></div>
                </div>

                <!-- 选中状态指示 -->
                <div class="selection-indicator" v-if="item.isClicked">
                    <i class="el-icon-success" style="color: #5FAAFF;"></i>
                </div>
            </li>

            <!-- 加载状态 -->
            <li v-if="isLoading" class="loading-item">
                <img class="loading-icon" src="@/assets/loading.gif" alt="">
            </li>

            <!-- 无更多数据 -->
            <li v-if="isNoMore && !isLoading" class="no-more-item">
                没有更多了
            </li>
        </ul>

        <!-- 创建分类模态框 -->
        <div v-if="showCreateAlbumModal" class="custom-modal-overlay" @click="closeCreateAlbumModal">
            <div class="custom-modal" @click.stop>
                <div class="modal-header">
                    <h3 class="modal-title">创建新分类</h3>
                    <button class="modal-close" @click="closeCreateAlbumModal">
                        <i class="el-icon-close"></i>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="create-album-form">
                        <el-form :model="newAlbumForm" :rules="albumFormRules" ref="albumForm" label-width="80px">
                            <el-form-item label="分类名称" prop="name">
                                <el-input v-model="newAlbumForm.name" placeholder="请输入分类名称"
                                    @keyup.enter.native="createAlbum" size="medium" clearable></el-input>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
                <div class="modal-footer">
                    <el-button @click="closeCreateAlbumModal" size="medium">取消</el-button>
                    <el-button type="primary" @click="createAlbum" :loading="creatingAlbum" size="medium">创建</el-button>
                </div>
            </div>
        </div>

        <!-- 添加图片弹窗 -->
        <AddPhotosModal :visible="showAddPhotosModal" :album-id="currentAlbumForAdd ? currentAlbumForAdd.idAlbum : ''"
            :album-name="currentAlbumForAdd ? currentAlbumForAdd.name : ''" :chat-user-info="chatUserInfo"
            @close="handleAddPhotosModalClose"
            @photos-added="handlePhotosAdded" />
    </div>
</template>

<script>
import { getGalleryPhotos, sendForModeration, getConnectionPhotos } from '@/api/talkytimes/message'
import imagePreview from '@/components/imagePreviewForAttachment.vue'
import { deletePhoto, getPhotoAlbumList, createPhotoAlbum, deletePhotoAlbum, addPhotosToAlbum, getEmailPhotoForbiddenTags } from '@/api/talkytimes/attachment'
import AddPhotosModal from './AddPhotosModal.vue'

export default {
    name: 'PhotoLibrary',
    components: { imagePreview, AddPhotosModal },
    props: {
        chatUserInfo: {
            type: Object,
            default: () => ({})
        },
        editMode: {
            type: Boolean,
            default: false
        },
        approvedOnly: {
            type: Boolean,
            default: false
        },
        currentMessageType: {
            type: String,
            default: 'chat'
        },
        showApprovedOnly: {
            type: Boolean,
            default: false
        },
        showEmailTags: {
            type: Boolean,
            default: false
        },
        showNewsFeedOnly: {
            type: Boolean,
            default: false
        },
        showMasSendingOnly: {
            type: Boolean,
            default: false
        },
        forbiddenTags: {
            type: Array,
            default: () => []
        },
        enableForbiddenTags: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            photoList: [],
            statusFilter: 'approved',
            statusOptions: [
                { label: 'All', value: 'all' },
                { label: 'Approved', value: 'approved' },
                { label: 'Temporary', value: 'temporary' },
                { label: 'Special', value: 'special' },
                { label: 'Special +', value: 'special_plus' },
                { label: 'Declined', value: 'declined' },
            ],
            // 图片分类标签
            selectedCategory: 'all_available',
            categoryOptions: [
                { label: 'All available', value: 'all_available' },
                { label: 'Basic', value: 'basic' },
                { label: 'Pre-special', value: 'pre_special' },
                { label: 'Special', value: 'special' },
                { label: 'Special +', value: 'special_plus' },
            ],
            // Show only unseen 筛选条件
            showOnlyUnseen: true,
            limit: 50,
            cursor: '',
            isLoading: false,
            isNoMore: false,
            hasError: false, // 添加错误状态标志
            previewImageList: [],
            // 分类相关数据
            albumList: [],
            selectedAlbum: 'all',
            showCreateAlbumModal: false,
            newAlbumForm: {
                name: ''
            },
            albumFormRules: {
                name: [
                    { required: true, message: '请输入分类名称', trigger: 'blur' },
                    { min: 1, max: 50, message: '分类名称长度在 1 到 50 个字符', trigger: 'blur' }
                ]
            },
            creatingAlbum: false,
            // 添加图片弹窗相关
            showAddPhotosModal: false,
            currentAlbumForAdd: null,
            // 本地禁止标签，用于优先使用
            localForbiddenTags: [],
            // 用于强制重新渲染infinite-scroll指令
            infiniteScrollKey: 0
        }
    },
    computed: {
        // 确保forbiddenTags始终是数组类型，优先使用本地数据，然后使用prop
        safeForbiddenTags() {
            if (this.localForbiddenTags.length > 0) {
                return this.localForbiddenTags;
            }
            return Array.isArray(this.forbiddenTags) ? this.forbiddenTags : [];
        },
        // 根据消息类型过滤分类选项，聊天、群发、Icebreakers模式下隐藏Special和Special +
        filteredCategoryOptions() {
            // newsFeed模式下只显示 All available
            if (this.showNewsFeedOnly) {
                return this.categoryOptions.filter(item => item.value === 'all_available');
            }
            
            // 聊天、群发、Icebreakers模式下需要隐藏Special和Special +
            const shouldHideSpecial = 
                (this.currentMessageType === 'chat' || 
                 this.currentMessageType === 'icebreakers' ||
                 this.currentMessageType === 'masSending' ||
                 this.showMasSendingOnly) &&
                !this.showEmailTags;
            
            let filteredOptions = [...this.categoryOptions];
            
            if (shouldHideSpecial) {
                filteredOptions = filteredOptions.filter(item => 
                    item.value !== 'special' && item.value !== 'special_plus'
                );
            }
            
            // 根据禁止标签过滤分类选项（适用于所有模式，包括邮件和post）
            if (this.safeForbiddenTags.length > 0) {
                filteredOptions = filteredOptions.filter(item => {
                    // 如果禁止标签包含'special'，则隐藏'special'选项
                    if (item.value === 'special' && this.safeForbiddenTags.includes('special')) {
                        return false;
                    }
                    // 如果禁止标签包含'special_plus'，则隐藏'special_plus'选项
                    if (item.value === 'special_plus' && this.safeForbiddenTags.includes('special_plus')) {
                        return false;
                    }
                    return true;
                });
            }
            
            return filteredOptions;
        },
        // 根据不同的消息类型过滤标签选项
        filteredStatusOptions() {
            let filteredOptions = [];

            if (this.editMode) {
                // 编辑模式下显示所有标签
                filteredOptions = this.statusOptions;
            } else if (this.showApprovedOnly) {
                // chat模式：只显示Approved标签
                filteredOptions = this.statusOptions.filter(item => item.value === 'approved');
            } else if (this.currentMessageType === 'chat' && !this.showEmailTags && !this.showNewsFeedOnly && !this.showMasSendingOnly) {
                // chat模式：过滤掉special和special+标签选项
                filteredOptions = this.statusOptions.filter(item => 
                    item.value !== 'special' && item.value !== 'special_plus'
                );
            } else if (this.showEmailTags) {
                // email模式：显示Approved、Temporary、Special、Special +标签，但需要根据禁止标签过滤
                filteredOptions = this.statusOptions.filter(item =>
                    ['approved', 'temporary', 'special', 'special_plus'].includes(item.value)
                );

                // 根据禁止标签进一步过滤
                if (this.safeForbiddenTags.length > 0) {
                    filteredOptions = filteredOptions.filter(item => {
                        // 如果禁止标签包含'special'，则隐藏'special'选项
                        if (item.value === 'special' && this.safeForbiddenTags.includes('special')) {
                            return false;
                        }
                        // 如果禁止标签包含'special_plus'，则隐藏'special_plus'选项
                        if (item.value === 'special_plus' && this.safeForbiddenTags.includes('special_plus')) {
                            return false;
                        }
                        return true;
                    });
                }
            } else if (this.showNewsFeedOnly) {
                // newsFeed模式：只显示Approved标签
                filteredOptions = this.statusOptions.filter(item => item.value === 'approved');
            } else if (this.showMasSendingOnly) {
                // masSending模式：只显示Approved标签，不允许Special和Special+
                filteredOptions = this.statusOptions.filter(item => item.value === 'approved');
            } else {
                // 默认显示所有标签
                filteredOptions = this.statusOptions;
            }

            return filteredOptions;
        }
    },
    watch: {
        statusFilter: {
            handler(newVal, oldVal) {
                // 避免初始化时触发
                if (oldVal !== undefined) {
                    this.refresh();
                }
            }
        },
        selectedCategory: {
            handler(newVal, oldVal) {
                // 避免初始化时触发
                if (oldVal !== undefined) {
                    this.refresh();
                }
            }
        },
        editMode: {
            handler(newVal) {
                if (newVal) {
                    // 进入编辑模式时，设置状态为 'all' 并重新加载
                    this.statusFilter = 'all';
                    this.selectedAlbum = 'all'; // 确保在编辑模式下始终选择 'all' 分类
                } else {
                    // 退出编辑模式时，根据消息类型设置默认状态
                    if (this.showApprovedOnly || this.showNewsFeedOnly || this.showMasSendingOnly) {
                        this.statusFilter = 'approved';
                    } else if (this.showEmailTags) {
                        this.statusFilter = 'approved';
                    } else if (this.currentMessageType === 'chat' && !this.showEmailTags && !this.showNewsFeedOnly && !this.showMasSendingOnly) {
                        this.statusFilter = 'approved';
                    }
                }
                this.refresh();
            }
        },
        chatUserInfo: {
            handler(newVal, oldVal) {
                // 当聊天用户信息变化时，刷新数据
                if (newVal && oldVal && newVal.userId !== oldVal.userId) {
                    this.refresh();
                }
            },
            deep: true
        },
        currentMessageType: {
            handler(newVal, oldVal) {
                // 当消息类型切换时，重新调整媒体库数据（避免初始化时触发）
                if (oldVal !== undefined && newVal !== oldVal) {
                    
                    // 如果切换到邮件或post模式，先加载 forbiddenTags
                    if (newVal === 'email' || newVal === 'postView' || this.showEmailTags || this.enableForbiddenTags) {
                        this.loadForbiddenTags().then(() => {
                            // 根据新的消息类型设置默认状态过滤器
                            if (this.editMode) {
                                this.statusFilter = 'all';
                            } else if (this.showApprovedOnly || this.showNewsFeedOnly || this.showMasSendingOnly) {
                                this.statusFilter = 'approved';
                            } else if (this.showEmailTags) {
                                this.statusFilter = 'approved';
                            } else if (this.currentMessageType === 'chat' && !this.showEmailTags && !this.showNewsFeedOnly && !this.showMasSendingOnly) {
                                this.statusFilter = 'approved';
                            } else {
                                // statusFilter 改变会触发 refresh，这里不需要再调用
                            }
                            
                            // 如果切换到聊天、群发、Icebreakers模式，且当前选择的是Special或Special+，切换到all_available
                            const shouldHideSpecial = 
                                (this.currentMessageType === 'chat' || 
                                 this.currentMessageType === 'icebreakers' ||
                                 this.currentMessageType === 'masSending' ||
                                 this.showMasSendingOnly) &&
                                !this.showEmailTags;
                            
                            if (shouldHideSpecial && (this.selectedCategory === 'special' || this.selectedCategory === 'special_plus')) {
                                this.selectedCategory = 'all_available';
                            }
                        });
                    } else {
                        // 根据新的消息类型设置默认状态过滤器
                        if (this.editMode) {
                            this.statusFilter = 'all';
                        } else if (this.showApprovedOnly || this.showNewsFeedOnly || this.showMasSendingOnly) {
                            this.statusFilter = 'approved';
                        } else if (this.showEmailTags) {
                            this.statusFilter = 'approved';
                        } else if (this.currentMessageType === 'chat' && !this.showEmailTags && !this.showNewsFeedOnly && !this.showMasSendingOnly) {
                            this.statusFilter = 'approved';
                        } else {
                            // statusFilter 改变会触发 refresh，这里不需要再调用
                        }
                        
                        // 如果切换到聊天、群发、Icebreakers模式，且当前选择的是Special或Special+，切换到all_available
                        const shouldHideSpecial = 
                            (this.currentMessageType === 'chat' || 
                             this.currentMessageType === 'icebreakers' ||
                             this.currentMessageType === 'masSending' ||
                             this.showMasSendingOnly) &&
                            !this.showEmailTags;
                        
                        if (shouldHideSpecial && (this.selectedCategory === 'special' || this.selectedCategory === 'special_plus')) {
                            this.selectedCategory = 'all_available';
                        }
                    }
                }
            }
        }
    },
    mounted() {
        // 根据消息类型设置默认的状态过滤器（不触发watch，因为data中已有默认值）
        // 如果需要修改默认值，使用 $nextTick 确保在初始化完成后再设置
        this.$nextTick(() => {
            let needSetStatusFilter = false;
            let newStatusFilter = this.statusFilter;
            
            if (this.editMode) {
                // 编辑模式下默认显示所有照片
                if (this.statusFilter !== 'all') {
                    newStatusFilter = 'all';
                    needSetStatusFilter = true;
                }
                this.selectedAlbum = 'all'; // 确保在编辑模式下始终选择 'all' 分类
            } else if (this.showApprovedOnly || this.showNewsFeedOnly || this.showMasSendingOnly) {
                if (this.statusFilter !== 'approved') {
                    newStatusFilter = 'approved';
                    needSetStatusFilter = true;
                }
            } else if (this.showEmailTags) {
                if (this.statusFilter !== 'approved') {
                    newStatusFilter = 'approved';
                    needSetStatusFilter = true;
                }
            } else if (this.currentMessageType === 'chat' && !this.showEmailTags && !this.showNewsFeedOnly && !this.showMasSendingOnly) {
                if (this.statusFilter !== 'approved') {
                    newStatusFilter = 'approved';
                    needSetStatusFilter = true;
                }
            }
            
            this.loadAlbums();
            
            // 如果状态过滤器需要改变，设置它（会触发watch并调用refresh）
            // 否则直接加载照片（避免重复调用）
            if (needSetStatusFilter) {
                this.statusFilter = newStatusFilter;
            } else {
                // 直接加载照片，不通过watch触发
                console.log('[mounted] 直接加载照片，先调用 loadForbiddenTags');
                this.loadForbiddenTags().then(() => {
                    console.log('[mounted] loadForbiddenTags 完成，调用 loadPhotos');
                    this.loadPhotos();
                });
            }
        });

        // 添加键盘事件监听
        document.addEventListener('keydown', this.handleKeydown);
    },

    beforeDestroy() {
        // 移除键盘事件监听
        document.removeEventListener('keydown', this.handleKeydown);
    },
    methods: {
        // 加载照片数据
        async loadPhotos(isLoadMore = false) {
            console.log('[loadPhotos] 开始执行, isLoadMore:', isLoadMore, 'currentMessageType:', this.currentMessageType);
            
            // 首次加载时，在需要的情况下先加载 forbiddenTags（在检查 isLoading 之前）
            let currentForbiddenTags = [];
            if (!isLoadMore) {
                console.log('[loadPhotos] 首次加载，检查是否需要加载 forbiddenTags');
                const needLoadForbiddenTags = 
                    this.enableForbiddenTags || 
                    this.currentMessageType === 'chat' || 
                    this.currentMessageType === 'newsFeed' || 
                    this.currentMessageType === 'icebreakers' ||
                    this.currentMessageType === 'email' ||
                    this.currentMessageType === 'postView' ||
                    this.showNewsFeedOnly ||
                    this.showEmailTags;
                
                console.log('[loadPhotos] needLoadForbiddenTags:', needLoadForbiddenTags);
                console.log('[loadPhotos] localForbiddenTags:', this.localForbiddenTags);
                console.log('[loadPhotos] forbiddenTags prop:', this.forbiddenTags);
                
                if (needLoadForbiddenTags) {
                    // 如果 forbiddenTags 还没有加载，先加载
                    if (this.localForbiddenTags.length === 0 && 
                        (!this.forbiddenTags || this.forbiddenTags.length === 0)) {
                        console.log('[loadPhotos] 开始等待 loadForbiddenTags...');
                        await this.loadForbiddenTags();
                        console.log('[loadPhotos] loadForbiddenTags 完成, localForbiddenTags:', this.localForbiddenTags);
                    }
                    // 使用最新的 forbiddenTags（优先使用 localForbiddenTags）
                    currentForbiddenTags = this.localForbiddenTags.length > 0 
                        ? this.localForbiddenTags 
                        : (Array.isArray(this.forbiddenTags) ? this.forbiddenTags : []);
                    console.log('[loadPhotos] currentForbiddenTags:', currentForbiddenTags);
                }
            } else {
                // 加载更多时，使用当前的 safeForbiddenTags
                currentForbiddenTags = this.safeForbiddenTags;
                console.log('[loadPhotos] 加载更多, currentForbiddenTags:', currentForbiddenTags);
            }
            
            // 在等待 forbiddenTags 加载完成后，再检查 isLoading（避免 refresh 时被阻止）
            if (this.isLoading && !isLoadMore) {
                console.log('[loadPhotos] 首次加载时 isLoading 为 true，可能是 refresh 中设置的，继续执行');
            } else if (this.isLoading) {
                console.log('[loadPhotos] 正在加载中，直接返回');
                return;
            }
            
            // 如果有错误且不是加载更多，直接返回
            if (this.hasError && !isLoadMore) {
                console.log('[loadPhotos] 有错误且不是加载更多，直接返回');
                return;
            }

            this.isLoading = true;
            this.hasError = false; // 重置错误状态

            // 获取自己的用户ID (pdUserId)
            const activeUser = localStorage.getItem('activeUser');
            const pdUserId = activeUser ? JSON.parse(activeUser).id : null;

            // 获取连接用户ID (idInterlocutor)
            // 在管理模式下，如果没有 idInterlocutor，使用自己的 pdUserId
            let idInterlocutor = this.chatUserInfo.userId || this.chatUserInfo.idInterlocutor || this.chatUserInfo.id_user || this.chatUserInfo.id;
            
            // 如果是管理模式且 idInterlocutor 无效，使用自己的 pdUserId
            if ((this.currentMessageType === 'management' || this.editMode) && (!idInterlocutor || idInterlocutor === 'default')) {
                idInterlocutor = pdUserId;
            }

            // 验证 idInterlocutor 是否有效
            if (!idInterlocutor || idInterlocutor === 'default') {
                console.error('无法获取有效的用户ID');
                this.isLoading = false;
                this.hasError = true;
                return;
            }

            // 使用新的连接照片接口，构建请求参数
            const params = {
                idInterlocutor: Number(idInterlocutor),
                limit: this.limit,
                statuses: ['approved', 'approved_by_ai']
            };

            // 添加pdUserId（如果有值）
            if (pdUserId) {
                params.pdUserId = Number(pdUserId);
            }

            // 根据选择的分类构建请求参数
            if (this.selectedCategory === 'all_available') {
                console.log('[loadPhotos] 分类: all_available');
                // 分类1: All available - 只有statuses和excludeConnectionStatuses
                // 对于聊天、群发、Icebreakers、newsFeed模式，直接过滤掉 Special 和 Special +
                // 对于邮件和post模式，如果没有 special、special_plus 权限，使用 excludeTags 排除掉
                const excludeTagsToAdd = [];
                
                // 聊天、群发、Icebreakers、newsFeed模式：直接过滤掉 special 和 special_plus
                const shouldExcludeSpecialForMode = 
                    (this.currentMessageType === 'chat' || 
                     this.currentMessageType === 'icebreakers' ||
                     this.currentMessageType === 'masSending' ||
                     this.currentMessageType === 'newsFeed' ||
                     this.showNewsFeedOnly ||
                     this.showMasSendingOnly) &&
                    !this.showEmailTags;
                
                console.log('[loadPhotos] shouldExcludeSpecialForMode:', shouldExcludeSpecialForMode);
                
                if (shouldExcludeSpecialForMode) {
                    excludeTagsToAdd.push('special', 'special_plus');
                    console.log('[loadPhotos] 模式过滤: 添加 special 和 special_plus');
                } else {
                    // 邮件和post模式：根据 forbiddenTags 过滤
                    // 使用当前加载的 forbiddenTags（首次加载时使用 currentForbiddenTags，加载更多时使用 safeForbiddenTags）
                    const tagsToCheck = !isLoadMore ? currentForbiddenTags : this.safeForbiddenTags;
                    console.log('[loadPhotos] 邮件/post模式, tagsToCheck:', tagsToCheck);
                    if (tagsToCheck.includes('special')) {
                        excludeTagsToAdd.push('special');
                        console.log('[loadPhotos] 添加 special 到 excludeTags');
                    }
                    if (tagsToCheck.includes('special_plus')) {
                        excludeTagsToAdd.push('special_plus');
                        console.log('[loadPhotos] 添加 special_plus 到 excludeTags');
                    }
                }
                
                if (excludeTagsToAdd.length > 0) {
                    params.excludeTags = excludeTagsToAdd;
                    console.log('[loadPhotos] 最终 params.excludeTags:', params.excludeTags);
                } else {
                    console.log('[loadPhotos] 没有添加 excludeTags');
                }
            } else if (this.selectedCategory === 'basic') {
                // 分类2: Basic - excludeTags: ["pre_special", "special", "special_plus"]
                params.excludeTags = ['pre_special', 'special', 'special_plus'];
            } else if (this.selectedCategory === 'pre_special') {
                // 分类3: Pre-special - tags: ["pre_special"]
                params.tags = ['pre_special'];
            } else if (this.selectedCategory === 'special') {
                // 分类4: Special - tags: ["special"]
                params.tags = ['special'];
            } else if (this.selectedCategory === 'special_plus') {
                // 分类5: Special + - tags: ["special_plus"]
                params.tags = ['special_plus'];
            }

            // 对于聊天、群发、Icebreakers模式，直接添加 excludeTags 过滤掉 Special 和 Special +
            // 邮件和 post 模式不需要添加 excludeTags（除非在 All available 时根据 forbiddenTags 添加）
            // 注意：如果用户选择了 Special 或 Special + 分类，则使用 tags，不添加 excludeTags
            // 注意：如果已经在 All available 时根据 forbiddenTags 添加了 excludeTags，这里不再重复添加
            const isNeedExcludeSpecialTags = 
                (this.currentMessageType === 'chat' || 
                 this.currentMessageType === 'icebreakers' ||
                 this.currentMessageType === 'masSending' ||
                 this.showNewsFeedOnly ||
                 this.showMasSendingOnly) &&
                !this.showEmailTags &&
                this.selectedCategory !== 'special' &&
                this.selectedCategory !== 'special_plus' &&
                this.selectedCategory !== 'all_available'; // All available 时已经根据 forbiddenTags 处理过了
            
            if (isNeedExcludeSpecialTags) {
                // 直接添加 excludeTags，过滤掉 special 和 special_plus
                const excludeTagsToAdd = ['special', 'special_plus'];
                
                // 如果已经有 excludeTags，合并去重；否则创建新的
                if (params.excludeTags && Array.isArray(params.excludeTags)) {
                    params.excludeTags = [...new Set([...params.excludeTags, ...excludeTagsToAdd])];
                } else {
                    params.excludeTags = excludeTagsToAdd;
                }
            }

            // Show only unseen 筛选条件
            if (this.showOnlyUnseen) {
                // 邮件模式只传accessed，其他模式（包括postView、newsFeed创建帖子、聊天、群发、Icebreakers）传accessed和sent
                if ((this.showEmailTags || this.currentMessageType === 'email') && this.currentMessageType !== 'postView') {
                    params.excludeConnectionStatuses = ['accessed'];
                } else {
                    // postView、newsFeed、chat、masSending、icebreakers等模式都传accessed和sent
                    params.excludeConnectionStatuses = ['accessed','sent'];
                }
            }

            // 如果选择了特定相册，添加相册ID（非编辑模式）
            if (!this.editMode && this.selectedAlbum && this.selectedAlbum !== 'all') {
                params.idAlbum = Number(this.selectedAlbum);
            }

            // 分页参数
            if (isLoadMore && this.cursor) {
                params.cursor = String(this.cursor);
            }

            getConnectionPhotos(params).then(res => {
                // 响应格式：{code: 200, data: {photos: [...], cursor: "..."}}
                const photosData = res.data || res;
                const newPhotos = (photosData.photos || []).map(item => ({
                    ...item,
                    url: item.urls?.urlPreview || item.urls?.urlStandard || '',
                    originalUrl: item.urls?.urlOriginal || item.urls?.urlStandard || '',
                    originalName: item.filename || '图片',
                    fileCateType: 1,
                    isClicked: false,
                    isHovered: false,
                    // 新接口返回 connectionStatus：accessed/sent/...，复用原有UI字段 casualStatus
                    casualStatus: item.connectionStatus || item.casualStatus,
                    // 处理标签格式，如果tags是字符串数组，转换为对象格式
                    tags: Array.isArray(item.tags) ? item.tags.map(tag => 
                        typeof tag === 'string' ? { code: tag } : tag
                    ) : [],
                }));

                // 接口返回的数据已经是能发的数据，前端不再需要过滤（excludeTags已在请求参数中处理）
                if (isLoadMore) {
                    this.photoList = this.photoList.concat(newPhotos);
                    // 更新预览图片列表，保持索引一致
                    this.previewImageList = this.photoList.map(item => item.originalUrl);
                } else {
                    this.photoList = newPhotos;
                    this.previewImageList = newPhotos.map(item => item.originalUrl);
                }

                // 确保 previewImageList 和 photoList 的长度一致
                if (this.previewImageList.length !== this.photoList.length) {
                    console.warn('预览图片列表长度与照片列表长度不一致，正在修复...');
                    this.previewImageList = this.photoList.map(item => item.originalUrl);
                }

                // 新接口返回的cursor在响应体的data.cursor字段
                this.cursor = photosData.cursor || '';

                this.isNoMore = newPhotos.length < this.limit;
                this.isLoading = false;
            }).catch(error => {
                console.error('加载照片失败:', error);
                // 请求失败时，设置错误状态并清空列表（仅首次加载时）
                if (!isLoadMore) {
                    this.hasError = true;
                    this.photoList = [];
                    this.previewImageList = [];
                    this.isNoMore = true; // 停止后续加载
                }
                this.isLoading = false;
            });
    },

        // 加载更多
        loadMore() {
            if (!this.isLoading && !this.isNoMore && !this.hasError) {
                this.loadPhotos(true);
            }
        },

        // 刷新数据
        refresh() {
            console.log('[refresh] 开始执行');
            this.cursor = '';
            this.isNoMore = false;
            this.hasError = false; // 重置错误状态
            this.photoList = [];
            this.previewImageList = []; // 清空预览图片列表
            
            // 先设置 isLoading = true，防止其他地方的 loadMore 被触发
            this.isLoading = true;

            // 强制重新渲染infinite-scroll指令
            this.infiniteScrollKey = Date.now();

            // 先重新加载禁止标签，再加载照片数据
            console.log('[refresh] 调用 loadForbiddenTags，然后 loadPhotos');
            this.loadForbiddenTags().then(() => {
                console.log('[refresh] loadForbiddenTags 完成，调用 loadPhotos');
                // 在 loadPhotos 中会重新设置 isLoading，这里不需要重置
                this.loadPhotos();
            });
        },

        // 切换选择状态
        toggleSelect(item) {
            if (!this.canSelect(item)) return;

            this.$set(item, 'isClicked', !item.isClicked);

            if (item.isClicked) {
                this.$emit('item-selected', item);
            } else {
                this.$emit('item-deselected', item);
            }
        },

        // 判断是否可以选中
        canSelect(item) {
            if (this.editMode) return true;

            // 处理status可能是字符串或对象的情况
            const statusValue = typeof item.status === 'string' ? item.status : (item.status?.code || '');
            
            // Declined/On moderation 状态禁止选中
            if (statusValue && (statusValue.includes('declined') || statusValue.includes('on_moderation'))) {
                return false;
            }

            // Declined 分类下禁止选中
            if (this.statusFilter === 'declined') {
                return false;
            }

            // 接口返回的数据已经是能发的数据，不需要再根据标签过滤
            return true;
        },

        // 获取鼠标样式
        getCursorStyle(item) {
            if (this.editMode) return 'pointer';
            if (!this.canSelect(item)) return 'not-allowed';
            return 'pointer';
        },

        // 判断是否禁用
        isDisabled(item) {
            return !this.canSelect(item);
        },

        // 判断是否显示蒙版
        shouldShowOverlay(item) {
            // 管理页面模式下不显示蒙版
            if (this.currentMessageType === 'management') {
                return false;
            }
            // 处理status可能是字符串或对象的情况
            const statusValue = typeof item.status === 'string' ? item.status : (item.status?.code || '');
            if (!this.editMode && statusValue && 
                (statusValue.includes('declined') || statusValue.includes('on_moderation'))) {
                return true;
            }
            if (this.statusFilter === 'declined') return true;
            // 接口返回的数据已经是能发的数据，不需要根据标签显示蒙版
            return false;
        },

        // 选择筛选状态
        selectStatus(value) {
            this.statusFilter = value;

            // 筛选条件改变时，直接刷新数据（refresh方法会处理照片数量统计）
            this.refresh();
        },

        // 选择分类
        selectCategory(value) {
            this.selectedCategory = value;
            this.refresh();
        },

        // Show only unseen 筛选条件改变
        handleUnseenFilterChange() {
            this.refresh();
        },

        // 是否显示标签
        getIsShowTag(item) {
            // 处理status可能是字符串或对象的情况
            const statusValue = typeof item.status === 'string' ? item.status : (item.status?.code || '');
            if (statusValue && statusValue.includes('approved')) {
                return item.tags && item.tags.length > 0;
            }
            return true;
        },

        // 获取标签图标
        getTagIcon(item) {
            // 处理status可能是字符串或对象的情况
            const statusValue = typeof item.status === 'string' ? item.status : (item.status?.code || '');
            if (statusValue && statusValue.includes('approved')) {
                if (item.tags && item.tags.length > 0) {
                    const tagCode = typeof item.tags[0] === 'string' ? item.tags[0] : (item.tags[0]?.code || '');
                    switch (tagCode) {
                        case 'special_plus':
                            return require('@/assets/svg/special+.svg');
                        case 'pre_special':
                            return require('@/assets/svg/special-.svg');
                        default:
                            return require('@/assets/svg/special.svg');
                    }
                }
            } else if (statusValue && statusValue.includes('declined')) {
                return require('@/assets/svg/negative.svg');
            } else if (statusValue === 'on_moderation') {
                return require('@/assets/svg/clock.svg');
            }
            return '';
        },

        // 获取标签描述
        getTagDescription(item) {
            // 处理status可能是字符串或对象的情况
            const statusValue = typeof item.status === 'string' ? item.status : (item.status?.code || '');
            if (statusValue && statusValue.includes('approved')) {
                if (item.tags && item.tags.length > 0) {
                    const tagCode = typeof item.tags[0] === 'string' ? item.tags[0] : (item.tags[0]?.code || '');
                    switch (tagCode) {
                        case 'special_plus':
                            return '特殊+内容只能发送给某些用户，并且只能以独家帖子或邮件的形式发送';
                        case 'pre_special':
                            return 'AI预设';
                        default:
                            return '特殊内容只能发送给某些用户，并且只能通过独家帖子或邮件发送';
                    }
                }
            } else if (statusValue && statusValue.includes('declined')) {
                return '审核不通过，不符合审核标准';
            } else if (statusValue === 'on_moderation') {
                return '审核中';
            }
            return '';
        },

        // 是否显示重新审核按钮
        shouldShowReReview(item) {
            // 处理status可能是字符串或对象的情况
            const statusValue = typeof item.status === 'string' ? item.status : (item.status?.code || '');
            if (!statusValue) return false;
            if (statusValue.includes('declined')) return true;
            if (statusValue === 'on_moderation') return true;
            if (statusValue.includes('approved') && item.tags && item.tags.length > 0) return true;
            return false;
        },

        // 重新审核
        async reReview(item) {
            try {
                await sendForModeration({ idPhoto: item.idPhoto });
                this.$message.success('重新提审成功');
                this.refresh();
            } catch (error) {
                this.$message.error('重新提审失败');
            }
        },

        // 加载分类列表
        async loadAlbums() {
            try {
                // 获取用户ID
                const idUser = this.chatUserInfo.userId || this.chatUserInfo.idInterlocutor || this.chatUserInfo.id_user || this.chatUserInfo.id;
                const params = { limit: 100 };
                if (idUser) {
                    params.idUser = idUser;
                }
                const res = await getPhotoAlbumList(params);
                this.albumList = res.items || [];
            } catch (error) {
                console.error('加载分类列表失败:', error);
                this.albumList = [];
            }
        },

        // 选择分类
        selectAlbum(albumId) {
            this.selectedAlbum = albumId;
            this.refresh();
        },

        // 创建分类
        async createAlbum() {
            try {
                await this.$refs.albumForm.validate();
                this.creatingAlbum = true;

                const res = await createPhotoAlbum({ name: this.newAlbumForm.name });

                // 添加到分类列表
                this.albumList.push({
                    idAlbum: res.idAlbum,
                    name: this.newAlbumForm.name
                });

                this.$message.success('分类创建成功');
                this.closeCreateAlbumModal();

            } catch (error) {
                console.error('创建分类失败:', error);
                this.$message.error('创建分类失败');
            } finally {
                this.creatingAlbum = false;
            }
        },

        // 关闭创建分类模态框
        closeCreateAlbumModal() {
            this.showCreateAlbumModal = false;
            this.newAlbumForm.name = '';
            this.$refs.albumForm && this.$refs.albumForm.resetFields();
        },

        // 删除分类
        async deleteAlbum(album) {
            try {
                // 确认删除
                await this.$confirm(
                    `确定要删除分类"${album.name}"吗？`,
                    '删除分类',
                    {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }
                );

                // 调用删除API
                await deletePhotoAlbum({ idAlbum: album.idAlbum });

                // 从列表中移除
                this.albumList = this.albumList.filter(item => item.idAlbum !== album.idAlbum);

                // 如果删除的是当前选中的分类，切换到All并重新加载数据
                if (this.selectedAlbum === album.idAlbum) {
                    this.selectedAlbum = 'all';
                    this.refresh(); // 重新加载数据
                }

                this.$message.success('分类删除成功');

            } catch (error) {
                if (error !== 'cancel') {
                    console.error('删除分类失败:', error);
                    this.$message.error('删除分类失败');
                }
            }
        },

        // 处理键盘事件
        handleKeydown(event) {
            if (this.showCreateAlbumModal) {
                if (event.key === 'Escape') {
                    this.closeCreateAlbumModal();
                } else if (event.key === 'Enter' && event.ctrlKey) {
                    this.createAlbum();
                }
            }
        },

        // 添加图片到当前分类
        addPhotosToCurrentCategory() {
            if (this.selectedAlbum === 'all') {
                this.$message.warning('请先选择一个分类');
                return;
            }

            // 找到当前选中的相册信息
            const currentAlbum = this.albumList.find(album => album.idAlbum === this.selectedAlbum);
            if (!currentAlbum) {
                this.$message.error('未找到相册信息');
                return;
            }

            // 设置当前相册信息并打开弹窗
            this.currentAlbumForAdd = currentAlbum;
            this.showAddPhotosModal = true;
        },

        // 处理添加图片弹窗关闭
        handleAddPhotosModalClose() {
            this.showAddPhotosModal = false;
            this.currentAlbumForAdd = null;
        },

        // 处理图片添加成功
        handlePhotosAdded(addedPhotos) {
            // 可以在这里刷新当前相册的数据
            this.refresh();
        },

        // 获取当前筛选条件下的照片数量
        getCurrentFilterPhotoCount(status) {
            // 如果是当前选中的状态，返回当前显示的照片列表长度
            if (status === this.statusFilter) {
                return this.photoList.length;
            }

            // 对于其他状态，返回模拟数据（实际项目中应该从API获取）
            const mockCounts = {
                'all': 150,
                'approved': 50,
                'temporary': 50,
                'special': 50,
                'special_plus': 50,
                'declined': 20
            };

            return mockCounts[status] || 0;
        },

        // 删除选中项
        async deleteItems(items) {
            if (!items || items.length === 0) {
                return;
            }

            try {
                // 调用删除API
                const itemIds = items.map(item => item.idPhoto || item.id);

                // 批量删除照片
                for (const id of itemIds) {
                    await deletePhoto({ idPhoto: id });
                }

                // 从当前列表中移除选中的项目
                this.photoList = this.photoList.filter(photo => {
                    const photoId = photo.idPhoto || photo.id;
                    return !itemIds.includes(photoId);
                });

                // 显示删除成功消息
                this.$message.success(`成功删除 ${items.length} 张照片`);

            } catch (error) {
                console.error('删除照片失败:', error);
                this.$message.error('删除失败，请重试');
            }
        },

        // 获取预览图片的索引
        getPreviewIndex(item) {
            // 在 previewImageList 中查找当前图片的索引
            const index = this.previewImageList.indexOf(item.originalUrl);
            return index >= 0 ? index : 0;
        },

        // 加载禁止标签
        async loadForbiddenTags() {
            console.log('[loadForbiddenTags] 开始执行');
            // 对于 newsfeed、chat、icebreakers、email、postView 模式都需要加载 forbidden-tags
            const needLoadForbiddenTags = 
                this.enableForbiddenTags || 
                this.currentMessageType === 'chat' || 
                this.currentMessageType === 'newsFeed' || 
                this.currentMessageType === 'icebreakers' ||
                this.currentMessageType === 'email' ||
                this.currentMessageType === 'postView' ||
                this.showNewsFeedOnly ||
                this.showEmailTags;
            
            console.log('[loadForbiddenTags] needLoadForbiddenTags:', needLoadForbiddenTags, 'currentMessageType:', this.currentMessageType);
            
            if (!needLoadForbiddenTags) {
                console.log('[loadForbiddenTags] 不需要加载，返回空数组');
                this.localForbiddenTags = [];
                return Promise.resolve();
            }
            
            const idInterlocutor = this.chatUserInfo.userId || this.chatUserInfo.idInterlocutor || this.chatUserInfo.id_user || this.chatUserInfo.id;
            console.log('[loadForbiddenTags] 调用 API, idInterlocutor:', idInterlocutor);
            
            const result = await getEmailPhotoForbiddenTags({ 
                idInterlocutor: idInterlocutor
            });
            
            console.log('[loadForbiddenTags] API 返回结果:', result);
            this.localForbiddenTags = Array.isArray(result) ? result : [];
            console.log('[loadForbiddenTags] 设置 localForbiddenTags:', this.localForbiddenTags);
            return Promise.resolve();
        },

        // 清理组件状态
        cleanup() {
            // 重置所有状态变量
            this.photoList = [];
            this.previewImageList = [];
            this.cursor = '';
            this.isLoading = false;
            this.isNoMore = false;
            this.statusFilter = 'approved';
            this.selectedAlbum = 'all';
            
            // 清理禁止标签
            this.localForbiddenTags = [];
            
            // 强制重新渲染infinite-scroll指令
            this.infiniteScrollKey = Date.now();
        }
    }
}
</script>

<style lang="scss" scoped>
.photo-library {
    height: 100%;
    display: flex;
    flex-direction: column;
}

.album-filter {
    // margin-bottom: 20px;
    background: #f8f9fa;
    border-radius: 12px;
    // padding: 16px;

    .album-tabs {
        display: flex;
        gap: 8px;
        overflow-x: auto;
        padding-bottom: 4px;
        align-items: center;

        &::-webkit-scrollbar {
            height: 4px;
        }

        &::-webkit-scrollbar-track {
            background: #f1f1f1;
            border-radius: 2px;
        }

        &::-webkit-scrollbar-thumb {
            background: #c1c1c1;
            border-radius: 2px;

            &:hover {
                background: #a8a8a8;
            }
        }

        .album-item {
            display: flex;
            align-items: center;
            gap: 4px;
            flex-shrink: 0;
        }

        .album-tab {
            padding: 10px 20px;
            border: 2px solid #e4e7ed;
            border-radius: 25px;
            background: #fff;
            color: #606266;
            font-size: 14px;
            font-weight: 500;
            cursor: pointer;
            transition: all 0.3s ease;
            white-space: nowrap;
            flex-shrink: 0;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

            &:hover {
                border-color: #409eff;
                color: #409eff;
                transform: translateY(-1px);
                box-shadow: 0 4px 8px rgba(64, 158, 255, 0.15);
            }

            &.selected {
                background: linear-gradient(135deg, #409eff 0%, #36a3f7 100%);
                border-color: #409eff;
                color: #fff;
                box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
                transform: translateY(-1px);
            }

            &.add-album {
                border-style: dashed;
                border-color: #d9d9d9;
                color: #999;
                min-width: 48px;
                padding: 10px;
                display: flex;
                align-items: center;
                justify-content: center;
                background: #fafafa;

                &:hover {
                    border-color: #409eff;
                    color: #409eff;
                    background: #f0f8ff;
                    transform: translateY(-1px);
                    box-shadow: 0 4px 8px rgba(64, 158, 255, 0.15);
                }

                i {
                    font-size: 18px;
                    font-weight: bold;
                }
            }
        }

        .album-delete-btn {
            width: 24px;
            height: 24px;
            border: none;
            border-radius: 50%;
            background: #f5f5f5;
            color: #999;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: all 0.3s ease;
            flex-shrink: 0;

            &:hover {
                background: #ff4d4f;
                color: #fff;
                transform: scale(1.1);
                box-shadow: 0 2px 8px rgba(255, 77, 79, 0.3);
            }

            i {
                font-size: 12px;
            }
        }
    }
}

.status-filter-btns {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 10px 0;
    padding: 0 8px;
    gap: 12px;

    .status-buttons {
        display: flex;
        gap: 12px;
        flex-wrap: wrap;
        flex: 1;
    }

    .status-btn {
        padding: 8px 20px;
        border: 2px solid #e4e7ed;
        border-radius: 20px;
        background: #fff;
        color: #606266;
        font-size: 14px;
        font-weight: 500;
        cursor: pointer;
        transition: all 0.3s ease;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

        &:hover {
            border-color: #409eff;
            color: #409eff;
            transform: translateY(-1px);
            box-shadow: 0 4px 8px rgba(64, 158, 255, 0.15);
        }

        &.selected {
            background: linear-gradient(135deg, #409eff 0%, #36a3f7 100%);
            border-color: #409eff;
            color: #fff;
            box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
            transform: translateY(-1px);
        }
    }

    .add-photo-btn {
        padding: 8px 16px;
        border: 2px solid #67c23a;
        border-radius: 20px;
        background: #fff;
        color: #67c23a;
        font-size: 14px;
        font-weight: 500;
        cursor: pointer;
        transition: all 0.3s ease;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
        white-space: nowrap;
        display: flex;
        align-items: center;
        gap: 6px;

        &:hover {
            background: #67c23a;
            color: #fff;
            transform: translateY(-1px);
            box-shadow: 0 4px 8px rgba(103, 194, 58, 0.3);
        }

        i {
            font-size: 16px;
        }
    }

    .unseen-filter {
        display: flex;
        align-items: center;
        margin-left: auto;
        
        .toggle-switch {
            display: flex;
            align-items: center;
            cursor: pointer;
            user-select: none;
            
            input[type="checkbox"] {
                display: none;
                
                &:checked + .toggle-slider {
                    background-color: #409eff;
                    
                    &::before {
                        transform: translateX(20px);
                    }
                }
            }
            
            .toggle-slider {
                position: relative;
                width: 44px;
                height: 24px;
                background-color: #ccc;
                border-radius: 24px;
                transition: background-color 0.3s ease;
                margin-right: 8px;
                
                &::before {
                    content: '';
                    position: absolute;
                    width: 18px;
                    height: 18px;
                    border-radius: 50%;
                    background-color: white;
                    top: 3px;
                    left: 3px;
                    transition: transform 0.3s ease;
                    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
                }
            }
            
            .toggle-label {
                font-size: 14px;
                color: #606266;
                font-weight: 500;
            }
        }
    }
}

.photo-list {
    flex: 1;
    height: 100%;
    width: 100%;
    display: block;
    padding: 0;
    margin: 0;
    list-style: none;
    overflow-y: auto;

    .photo-item {
        position: relative;
        display: inline-block;
        margin: 1px;
        padding: 3px;
        vertical-align: top;
        box-sizing: border-box;
        text-align: center;
        border: 1px solid transparent;
        transition: all 0.2s;

        &.is-selected {
            border: 1px solid #2499FF;
            border-radius: 8px;
        }

        .image-container {
            width: 100px;
            height: 100px;
            position: relative;
            display: inline-block;

            &.disabled-image {
                opacity: 0.6;
            }

            .disabled-overlay {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                background: #fff;
                opacity: 0.5;
                pointer-events: none;
                z-index: 5;
            }

            ::v-deep .imagePreview {
                width: 150px;
                height: 150px;
                display: block;

                .preview-image {
                    width: 150px;
                    height: 150px;
                    object-fit: contain;
                    border-radius: 4px;
                }
            }
        }

        .media-icons-container {
            position: absolute;
            bottom: 4px;
            left: 4px;
            display: flex;
            align-items: center;
            gap: 4px;
            z-index: 10;
        }

        .media-tag,
        .media-tagSec {
            position: relative;
            background: rgba(20, 20, 20, 0.4);
            color: white;
            /* padding: 5px; */
            width: 20px;
            height: 20px;
            border-radius: 50px;
            display: flex;
            align-items: center;
            gap: 2px;
            transition: all 0.3s ease;
            cursor: pointer;
            display: flex;
            justify-content: center;
            align-items: center;

            .tag-icon {
                width: 10px;
                height: 10px;
            }

            &:hover {
                background: rgba(20, 20, 20, .6);
            }
        }

        .selection-indicator {
            position: absolute;
            right: 0;
            top: 2px;
        }
    }

    .loading-item,
    .no-more-item {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 40px;
        width: 100%;
        color: #999;
        font-size: 14px;

        .loading-icon {
            width: 30px;
            height: 30px;
            animation: rotate360 1s linear infinite;
        }
    }
}

@keyframes rotate360 {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}

.create-album-form {
    padding: 20px 0;
}

// 自定义弹窗样式
.custom-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    animation: fadeIn 0.3s ease;
}

.custom-modal {
    background: #fff;
    border-radius: 12px;
    width: 450px;
    max-width: 90vw;
    max-height: 90vh;
    overflow: hidden;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
    animation: slideIn 0.3s ease;
    display: flex;
    flex-direction: column;
}

.modal-header {
    background: linear-gradient(135deg, #409eff 0%, #36a3f7 100%);
    color: #fff;
    padding: 20px 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .modal-title {
        margin: 0;
        font-size: 18px;
        font-weight: 600;
        color: #fff;
    }

    .modal-close {
        background: none;
        border: none;
        color: #fff;
        font-size: 18px;
        cursor: pointer;
        padding: 4px;
        border-radius: 4px;
        transition: all 0.3s ease;

        &:hover {
            background: rgba(255, 255, 255, 0.1);
            transform: scale(1.1);
        }

        i {
            font-size: 18px;
        }
    }
}

.modal-body {
    padding: 24px;
    flex: 1;
    overflow-y: auto;

    .el-form-item__label {
        font-weight: 500;
        color: #333;
    }

    .el-input__inner {
        border-radius: 8px;
        border: 2px solid #e4e7ed;
        transition: all 0.3s ease;

        &:focus {
            border-color: #409eff;
            box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.1);
        }
    }
}

.modal-footer {
    padding: 20px 24px;
    border-top: 1px solid #f0f0f0;
    text-align: right;
    background: #fff;

    .el-button {
        border-radius: 8px;
        font-weight: 500;
        transition: all 0.3s ease;
        margin-left: 12px;

        &:hover {
            transform: translateY(-1px);
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
        }
    }
}

// 动画效果
@keyframes fadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

@keyframes slideIn {
    from {
        opacity: 0;
        transform: translateY(-20px) scale(0.95);
    }

    to {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
}
</style>
